"use strict";

import { StyleSheet } from 'react-native';
export const styles = StyleSheet.create({
  container: {
    // @ts-ignore
    cursor: 'grab'
  }
});
//# sourceMappingURL=styles.web.js.map